import React from 'react';

import styled from 'styled-components';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { toastOperations } from '@/redux/ducks/toast';

const decideBoxShadow = ({ theme, type }) => {
	switch (type) {
		case 'error':
			return theme.colors.error;
		case 'success':
			return theme.colors.success;
		default:
			return 'none';
	}
};

const decideBgColor = ({ type, theme }) => {
	switch (type) {
		case 'error':
			return theme.colors.error;
		case 'info':
			return theme.colors.primaryLight;
		default:
			return theme.colors.secondary;
	}
};

const decideBorder = ({ type, theme }) => {
	switch (type) {
		case 'error':
			return `1px solid #aa2e25`;
		case 'info':
			return `1px solid ${theme.colors.primary}`;
		default:
			return `1px solid ${theme.colors.secondaryDark}`;
	}
};

const decideTextColor = ({ type, theme }) => {
	switch (type) {
		case 'error':
			return theme.colors.white;
		case 'info':
			return theme.colors.menu;
		default:
			return theme.colors.white;
	}
};
const ToastBox = styled.div`
	position: fixed;
	top: 20px;
	left: 50%;
	transform: translateX(-50%);
	min-width: 200px;
	background-color: ${(props) => props.theme.colors.disabled};
	display: ${(props) => (props.isVisible ? 'block' : 'none')};
	z-index: 100000000; //To overcome the overlapping Notification bar
	border-radius: 4px;
	box-shadow: 0 6px 30px 0 ${(props) => decideBoxShadow(props)};
	background-color: ${(props) => decideBgColor(props)};
	border: ${(props) => decideBorder(props)};
	text-align: center;
	color: ${(props) => decideTextColor(props)};
	padding: 0 10px;
`;

/**
 * @Params
 *   isVisible @boolean @desc show/hide toast
 *   title @string @desc Bold Title for msg
 *   message @string
 *   type @enum{'success', 'error', 'info'} @desc dictates how the toast will look
 */
class ToastMessage extends React.Component {
	componentDidMount() {
		const { hideToast, duration = 1800 } = this.props;
		setTimeout(() => hideToast(), duration);
	}

	render() {
		const { isVisible, type, title, msg, hideToast } = this.props;
		return (
			<ToastBox type={type} isVisible={isVisible} onClick={() => hideToast()}>
				<h5>{title}</h5>
				<p>{msg}</p>
			</ToastBox>
		);
	}
}

ToastMessage.defaultProps = {
	isVisible: false,
	type: 'info',
	title: '',
	msg: '',
};

ToastMessage.propTypes = {
	hideToast: PropTypes.func.isRequired,
	isVisible: PropTypes.bool,
	type: PropTypes.string,
	title: PropTypes.string,
	msg: PropTypes.string,
};

export default connect((state) => state.toast, { ...toastOperations })(
	ToastMessage,
);
